// Utility functions for tarot card operations

/**
 * Fisher-Yates shuffle algorithm for truly random card shuffling
 */
export const shuffleCards = (cards) => {
  const shuffled = [...cards];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

/**
 * Draw random cards from deck
 */
export const drawCards = (deck, count) => {
  const shuffled = shuffleCards(deck);
  return shuffled.slice(0, count);
};

/**
 * Format card image path
 */
export const getCardImagePath = (filename) => {
  return `/cards/${filename}`;
};

/**
 * Animate card flip
 */
export const flipCard = (element) => {
  if (!element) return;
  element.style.transform = 'rotateY(180deg)';
  setTimeout(() => {
    element.style.transform = 'rotateY(0deg)';
  }, 600);
};
